import { useDispatch as useReduxDispatch } from "react-redux";
import type { AppDispatch } from "../rootReducer";

export const useAppDispatch = () => useReduxDispatch<AppDispatch>();
